var map = {
	"./bh-ico-active.svg": 1782,
	"./bh-ico.svg": 1783,
	"./bonus-ico-active.svg": 1784,
	"./bonus-ico.svg": 1785,
	"./deposit-ico.svg": 1786,
	"./deposit-ico.webp": 1787,
	"./edit-icon.svg": 1788,
	"./fb-ico.svg": 1789,
	"./instant-rebate-ico-active.svg": 1790,
	"./instant-rebate-ico.svg": 1791,
	"./mall-ico-active.svg": 1792,
	"./mall-ico.svg": 1793,
	"./msg-ico-active.svg": 1794,
	"./msg-ico.svg": 1795,
	"./pi-ico-active.svg": 1796,
	"./pi-ico.svg": 1797,
	"./rf-ico-active.svg": 1798,
	"./rf-ico.svg": 1799,
	"./rh-ico-active.svg": 1800,
	"./rh-ico.svg": 1801,
	"./th-ico-active.svg": 1802,
	"./th-ico.svg": 1803,
	"./vip-ico-active.svg": 1804,
	"./vip-ico.svg": 1805,
	"./withdrawal-ico.svg": 1806,
	"./withdrawal-ico.webp": 1807,
	"./wl-ico-active.svg": 1808,
	"./wl-ico.svg": 1809
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 467;